export default {
	data() {
		return {
			aisWebAPI: '1807502681',
			aisWebPass: 'e7119df3-cf96-11e7-a836-00505680c1b4'
		}
	},

	methods: {
		_AISWEB_URL(uri) {
			return `https://www.aisweb.aer.mil.br/api/?apiKey=${this.aisWebAPI}&apiPass=${this.aisWebPass}${uri}`
		},

		_getMetar(designativo) {
			return new Promise((resolve) => {
				let url = this._AISWEB_URL(`&area=met&icaoCode=${designativo}`)

				this._httpGetExternal(
					url,
					(resposta) => {
						let obj = {
							metar:
								resposta.getElementsByTagName('metar')[0].textContent == 'ND'
									? null
									: resposta.getElementsByTagName('metar')[0].textContent.split(' - ')[1],
							taf:
								resposta.getElementsByTagName('taf')[0].textContent == 'ND'
									? null
									: resposta.getElementsByTagName('taf')[0].textContent.split(' - ')[1]
						}

						resolve(obj)
					},
					'XML'
				)
			})
		},

		_getSuplemento(icao) {
			// http://www.aisweb.aer.mil.br/api/?apiKey={{api_key}}&apiPass={{api_pass}}&area=suplementos&IcaoCode={{aip_icao_code}}&s={{aip_s}}

			return new Promise((resolve) => {
				let url = this._AISWEB_URL(`&area=suplementos&IcaoCode=${icao}`)

				this._httpGetExternal(
					url,
					(resposta) => {
						let lista = []

						let item = resposta.getElementsByTagName('item')

						for (var i = 0; i < item.length; i++) {
							let n = {}

							n.id = item[i].getElementsByTagName('id')[0].textContent
							n.status = item[i].getElementsByTagName('status')[0].textContent
							n.n = item[i].getElementsByTagName('n')[0].textContent
							n.serie = item[i].getElementsByTagName('serie')[0].textContent
							n.tipo = item[i].getElementsByTagName('tipo')[0].textContent
							n.local = item[i].getElementsByTagName('local')[0].textContent
							n.dt = item[i].getElementsByTagName('dt')[0].textContent
							n.titulo = item[i].getElementsByTagName('titulo')[0].textContent
							n.texto = item[i].getElementsByTagName('texto')[0].textContent
							n.duracao = item[i].getElementsByTagName('duracao')[0].textContent
							n.ref = item[i].getElementsByTagName('ref')[0].textContent

							lista.push(n)
						}

						resolve(lista)
					},
					'XML'
				)
			})
		},

		_getNotam(icao) {
			return new Promise((resolve) => {
				let url = this._AISWEB_URL(`&area=notam&icaocode=${icao}`)

				this._httpGetExternal(
					url,
					(resposta) => {
						let lista = []
						let item = resposta.getElementsByTagName('item')

						for (var i = 0; i < item.length; i++) {
							let n = {}

							n.e = item[i].getElementsByTagName('e')[0].textContent
							n.id = item[i].getElementsByTagName('id')[0].textContent
							n.cod = item[i].getElementsByTagName('cod')[0].textContent
							n.status = item[i].getElementsByTagName('status')[0].textContent
							n.ref = item[i].getElementsByTagName('ref')[0].textContent
							n.cat = item[i].getElementsByTagName('cat')[0].textContent
							n.tp = item[i].getElementsByTagName('tp')[0].textContent
							n.dt = item[i].getElementsByTagName('dt')[0].textContent
							n.n = item[i].getElementsByTagName('n')[0].textContent
							n.loc = item[i].getElementsByTagName('loc')[0].textContent
							n.b = item[i].getElementsByTagName('b')[0].textContent
							n.c = item[i].getElementsByTagName('c')[0].textContent
							n.d = item[i].getElementsByTagName('d')[0].textContent
							n.f = item[i].getElementsByTagName('f')[0].textContent
							n.g = item[i].getElementsByTagName('g')[0].textContent
							n.nof = item[i].getElementsByTagName('nof')[0].textContent
							n.s = item[i].getElementsByTagName('s')[0].textContent
							n.geo = item[i].getElementsByTagName('geo')[0].textContent
							n.aero = item[i].getElementsByTagName('aero')[0].textContent
							n.cidade = item[i].getElementsByTagName('cidade')[0].textContent
							n.uf = item[i].getElementsByTagName('uf')[0].textContent
							n.origem = item[i].getElementsByTagName('origem')[0].textContent
							n.fir = item[i].getElementsByTagName('fir')[0].textContent
							n.traffic = item[i].getElementsByTagName('traffic')[0].textContent
							n.purpose = item[i].getElementsByTagName('purpose')[0].textContent
							n.scope = item[i].getElementsByTagName('scope')[0].textContent
							n.limits = item[i].getElementsByTagName('limits')[0].textContent
							n.nof_ref = item[i].getElementsByTagName('nof_ref')[0].textContent

							lista.push(n)
						}

						resolve(lista)
					},
					'XML'
				)
			})
		},

		_getNascerPor(designativo, inicio, fim) {
			return new Promise((resolve) => {
				let url = this._AISWEB_URL(`&area=sol&icaoCode=${designativo}&dt_i=${inicio}&dt_f=${fim}`)

				this._httpGetExternal(
					url,
					(resposta) => {
						let obj = {
							nascer:
								resposta.getElementsByTagName('sunrise')[0].textContent == 'ND'
									? null
									: resposta.getElementsByTagName('sunrise')[0].textContent,
							por:
								resposta.getElementsByTagName('sunset')[0].textContent == 'ND'
									? null
									: resposta.getElementsByTagName('sunset')[0].textContent
						}

						resolve(obj)
					},
					'XML'
				)
			})
		}
	}
}